import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["hidden", "fieldId"];

  connect() {
    this.field = document.getElementById(this.fieldIdTarget.value);
    this.fieldImage = document.getElementById(
      this.fieldIdTarget.value + "_image"
    );

    if (this.fieldIdTarget.dataset.multiple === "true") {
      this.selected = [];
    }
  }

  select(event) {
    // set id for file field
    this.field.value = event.target.dataset.id;

    // close modal
    var modal = document.getElementById("modal");
    modal.removeAttribute("src");
    modal.innerHTML = "";

    // add selected image filename
    this.fieldImage.src = event.target.src;

    // add class to img tag
    var image_tag =  document.getElementById("selected_image_id_image");
    if(!image_tag.classList.contains("image-preview")){
      image_tag.classList.add("image-preview")
    }
  }

  select_multiple(event) {
    const target = event.target;
    if (this.selected.includes(target.dataset.id)) {
      // remove from this.selected array
      for (var i = 0; i < this.selected.length; i++) {
        if (this.selected[i] === target.dataset.id) {
          this.selected.splice(i, 1);
          i--;
        }
      }
      event.target.classList.remove("active-borders");
    } else {
      this.selected.push(target.dataset.id);
      event.target.classList.add("active-borders");
    }
    this.field.value = this.selected;
  }
}
